import { axiosSecureInstance } from "./axios";
import { getUserID } from "../Utility/service";
import {
  LEADSLIFT_ACCOUNTS,
  LEADSLIFT_CREATE_POST,
} from "../constants/Api_constants";

const headers = {
  Authorization: `Bearer ${localStorage.getItem("leadsLiftLocationId")}`,
};

export const leadsLiftSocialAccount = async () => {
  try {
    const userId = getUserID();
    const response = await axiosSecureInstance.get(LEADSLIFT_ACCOUNTS(userId), {
      headers,
    });

    const data = response?.data;
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export const leadsLiftSocialPost = async (account, summary) => {
  const body = {
    accountIds: [account],
    summary,
    status: "draft",
    createdBy: "CollabAI",
    type: "post",
  };
  
  try {
    const userId = getUserID();
    const response = await axiosSecureInstance.post(
      LEADSLIFT_CREATE_POST(userId),
      body,
      { headers }
    );
    const data = response?.data;
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
